import { Component, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { NavParams } from "@ionic/angular";

@Component({
  selector: "app-fasting-duration-popup",
  templateUrl: "./fasting-duration-popup.component.html",
  styleUrls: ["./fasting-duration-popup.component.scss"],
})
export class FastingDurationPopupComponent implements OnInit {
  fastDuration;
  startTime;
  durations = [
    {
      fatingDuration: "12:12",
      hours: "12",
      level: "Beginner level",
      punchline: "Best for Newbies",
      color: "#00B05E",
      bottomLine: "A 12 hours fast with a 12 hours meal window",
      isSelected: true,
    },
    {
      fatingDuration: "14:10",
      hours: "14",
      level: "Medium level",
      punchline: "Best for All",
      color: "#F7C805",
      bottomLine: "A 14 hours fast with a 10 hours meal window",
      isSelected: false,
    },
    {
      fatingDuration: "16:08",
      hours: "16",
      level: "Expert level",
      punchline: "Best for Experts",
      color: "#FF56A2",
      bottomLine: "A 16 hours fast with a 8 hours meal window",
      isSelected: false,
    },
  ];

  constructor(
    private modalController: ModalController,
    private navParams: NavParams
  ) {
    this.fastDuration = Number(this.navParams.get("fastDuration"));
    this.startTime = this.navParams.get("startTime");
  }

  ngOnInit() {
    this.onCardSelect(this.fastDuration);
  }

  onCardSelect(hours) {
    this.fastDuration = hours;
    localStorage.setItem("fastDuration", this.fastDuration.toString());
    this.durations.forEach((duration) => {
      if (duration.hours == hours) {
        duration.isSelected = true;
      } else {
        duration.isSelected = false;
      }
    });

    this.selectHours();
  }

  close() {
    this.modalController.dismiss();
  }

  selectHours() {
    this.modalController.dismiss({
      startTime: this.startTime,
      fastDuration: this.fastDuration,
    });
  }
}
